import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import formatDate from './DynamicForm/TypeForm/TypeFormDate';
import DatePicker from 'react-datepicker';
import DateMask from './MaskedInput/DateMask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FilterDateRange = (props) => {
	const {
		config,
		dispatch,
		style,
		initialValue,
		separator_text
	} = props;
	const separator = separator_text || config.separator_text || '-';
	const initText = config.init_text || '';
	const [initDate, setInitDate] = useState(null);
	const [finishDate, setFinishDate] = useState(null);

	useEffect(() => {
		// Cargar valores iniciales desde URL params o initialValue
		const searchParams = Object.fromEntries(
			new URLSearchParams(window.location.search)
		);
		const initValue = searchParams[`${config.name_var}__init`] || initialValue?.init || '';
		const finishValue = searchParams[`${config.name_var}__finish`] || initialValue?.finish || '';

		if (initValue) {
			const date = formatDate.fromApiToPicker(initValue, true);
			setInitDate(date);
		}
		if (finishValue) {
			const date = formatDate.fromApiToPicker(finishValue, true);
			setFinishDate(date);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleInitDateChange = (date) => {
		setInitDate(date);
		const value = date ? formatDate.fromPickerToApi(date) : null;
		if (dispatch) {
			dispatch({ [`${config.name_var}__init`]: value }, config.name_var);
		}
	};

	const handleFinishDateChange = (date) => {
		setFinishDate(date);
		const value = date ? formatDate.fromPickerToApi(date) : null;
		if (dispatch) {
			dispatch({ [`${config.name_var}__finish`]: value }, config.name_var);
		}
	};

	return (
		<div className="mx-sm-0 mx-md-1 mt-2 mt-md-0 mr-1 mr-md-0" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', verticalAlign: 'middle' }}>
			<span className="form-control-sm mt-2 mr-1" style={{ 
				fontSize: 'inherit', 
				fontFamily: 'inherit', 
				fontWeight: 'inherit',
				lineHeight: 'inherit',
				padding: '0',
				border: 'none',
				background: 'transparent',
				display: 'inline-flex',
				alignItems: 'center',
				verticalAlign: 'middle'
			}}>
				{config.title}{initText ? ` ${initText}` : ''}
			</span>
			<div className="Datepicker-wrapper mt-2 mr-1" style={{ flex: '0 0 auto', display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle' }}>
				<DatePicker
					id={`${config.name_var}__init`}
					name={`${config.name_var}__init`}
					dateFormat="dd/MM/yyyy"
					selected={initDate}
					shouldCloseOnSelect
					onChange={handleInitDateChange}
					autocomplete="off"
					todayButton="Hoy"
					className="form-control form-control-sm BasicSelect mt-2 mr-1"
					customInput={<DateMask type="date" />}
					placeholderText="Desde"
				/>
				<FontAwesomeIcon icon="calendar" title="calendar" />
			</div>
			<span className="mt-2 mr-1" style={{ display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle' }}>{separator}</span>
			<div className="Datepicker-wrapper mt-2 mr-1" style={{ flex: '0 0 auto', display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle' }}>
				<DatePicker
					id={`${config.name_var}__finish`}
					name={`${config.name_var}__finish`}
					dateFormat="dd/MM/yyyy"
					selected={finishDate}
					shouldCloseOnSelect
					onChange={handleFinishDateChange}
					autocomplete="off"
					todayButton="Hoy"
					className="form-control form-control-sm BasicSelect mt-2 mr-1"
					customInput={<DateMask type="date" />}
					placeholderText="Hasta"
				/>
				<FontAwesomeIcon icon="calendar" title="calendar" />
			</div>
		</div>
	);
};

FilterDateRange.propTypes = {
	config: PropTypes.shape({
		name_var: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired
	}).isRequired,
	dispatch: PropTypes.func,
	style: PropTypes.object,
	initialValue: PropTypes.shape({
		init: PropTypes.string,
		finish: PropTypes.string
	}),
	separator_text: PropTypes.string
};

FilterDateRange.defaultProps = {
	dispatch: null,
	style: {},
	initialValue: null,
	separator_text: '-'
};

export default FilterDateRange;

